import { render } from "./DetailShipmentNoticeSupp.vue?vue&type=template&id=59a55118"
import script from "./DetailShipmentNoticeSupp.vue?vue&type=script&lang=js"
export * from "./DetailShipmentNoticeSupp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__